import { FreeBlock } from "../documents/free-block";

export class SaleFreeBlock extends FreeBlock {
	HideOnPrint:boolean = false;
	HideOnEmailSend:boolean = false;
	HideOnDownload:boolean = false;

	public constructor(data?:any){
		super(data);
		if (!data) return;
		this.HideOnPrint = data.HideOnPrint;
		this.HideOnEmailSend = data.HideOnEmailSend;
		this.HideOnDownload = data.HideOnDownload;
	}

	public getJSON(){
		return {
			...super.getJSON(),
			HideOnPrint: this.HideOnPrint,
			HideOnEmailSend: this.HideOnEmailSend,
			HideOnDownload: this.HideOnDownload,
		};
	}
}